import React, { useEffect, useRef } from 'react';

const WaveformVisualizer = ({ 
  isActive = false, 
  audioData = [],
  height = 200 
}) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    const width = canvas?.width;
    const canvasHeight = canvas?.height;

    const draw = () => {
      ctx?.clearRect(0, 0, width, canvasHeight);

      if (!isActive) {
        ctx.strokeStyle = 'var(--color-muted)';
        ctx.lineWidth = 2;
        ctx?.beginPath();
        ctx?.moveTo(0, canvasHeight / 2);
        ctx?.lineTo(width, canvasHeight / 2);
        ctx?.stroke();
        return;
      }

      const barWidth = width / 64;
      const gradient = ctx?.createLinearGradient(0, 0, 0, canvasHeight);
      gradient?.addColorStop(0, '#8B7355');
      gradient?.addColorStop(0.5, '#A8C5D1');
      gradient?.addColorStop(1, '#D4A574');

      for (let i = 0; i < 64; i++) {
        const value = audioData?.[i] || Math.random() * 0.5;
        const barHeight = (value * canvasHeight) / 2;
        const x = i * barWidth;
        const y = (canvasHeight - barHeight) / 2;

        ctx.fillStyle = gradient;
        ctx?.fillRect(x, y, barWidth - 2, barHeight);
      }

      if (isActive) {
        animationRef.current = requestAnimationFrame(draw);
      }
    };

    draw();

    return () => {
      if (animationRef?.current) {
        cancelAnimationFrame(animationRef?.current);
      }
    };
  }, [isActive, audioData]);

  return (
    <div className="waveform-visualizer bg-card rounded-lg border border-border p-4 shadow-soft">
      <div className="visualizer-header mb-3">
        <h3 className="text-sm font-heading font-semibold text-foreground">
          Визуализация аудио
        </h3>
      </div>
      
      <div className="visualizer-canvas bg-background rounded overflow-hidden">
        <canvas 
          ref={canvasRef} 
          width={800} 
          height={height}
          className="w-full"
          style={{ height: `${height}px` }}
        />
      </div>
    </div>
  );
};

export default WaveformVisualizer;